export const RECENT_DASHBOARDS_PRIORITY = 6;
export const ACTIONS_PRIORITY = 5;
export const DEFAULT_PRIORITY = 4;
export const PREFERENCES_PRIORITY = 3;
export const EXTENSIONS_PRIORITY = 2;
export const SEARCH_RESULTS_PRIORITY = 1; // Dynamic actions should be below static ones so the list doesn't 'jump' when they come in
